import { ROUTE_PATHS } from './navigation';

const systemsConfig = [
  {
    key: 'koleave',
    title: 'Koleave',
    subtitle: 'İzin, mesai ve vardiya işlemleri',
    icon: 'bx bx-calendar-check',
    url: process.env.REACT_APP_KOLEAVE_URL,
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    fallbackLabel: 'Erişim rehberini aç',
    helperText: 'Yetki ve kullanım akışı İK tarafından bu kanal üzerinden duyurulur.'
  },
  {
    key: 'pdks',
    title: 'PDKS / Giriş Sistemi',
    subtitle: 'Geçiş ve devam bilgileri',
    icon: 'bx bx-door-open',
    url: process.env.REACT_APP_PDKS_URL,
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`,
    fallbackLabel: 'Kullanım akışını görüntüle',
    helperText: 'Kart tanımları, geçiş kuralları ve vardiya esasları merkezi dokümanlarda yer alır.'
  },
  {
    key: 'forms',
    title: 'İK Form Merkezi',
    subtitle: 'Dilekçe, onboarding ve süreç dokümanları',
    icon: 'bx bx-file',
    fallbackPath: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    fallbackLabel: 'Form merkezine git',
    helperText: 'Tüm standart İK formları tek noktadan yönetilir.'
  }
];

export const hrSystems = systemsConfig.map((system) => {
  const hasExternalUrl = Boolean(system.url);

  return {
    ...system,
    href: hasExternalUrl ? system.url : system.fallbackPath,
    isExternal: hasExternalUrl,
    ctaLabel: hasExternalUrl ? 'Sistemi aç' : system.fallbackLabel
  };
});

export const onboardingJourney = [
  {
    id: 'preboarding',
    title: 'Preboarding',
    owner: 'İK Operasyon',
    timeline: 'İşe başlamadan önce',
    tasks: ['Kurum hesabı açılışı', 'Evrak kontrolü', 'İlk gün planının paylaşılması']
  },
  {
    id: 'first-day',
    title: 'İlk gün',
    owner: 'Yöneticisi ve İK',
    timeline: 'Gün 1',
    tasks: ['Kart ve giriş tanımları', 'Ekip tanıtımı', 'Temel sistemlere erişim']
  },
  {
    id: 'first-week',
    title: 'İlk hafta',
    owner: 'Birim yöneticisi',
    timeline: 'Gün 2-5',
    tasks: ['Rol beklentileri', 'Toplantı planı', 'İş güvenliği ve süreç dokümanları']
  },
  {
    id: 'first-month',
    title: 'İlk ay',
    owner: 'İK İş Ortağı',
    timeline: '30 gün',
    tasks: ['Uyum görüşmesi', 'Gelişim ihtiyaçları', 'Deneme süreci takip notları']
  }
];

export const onboardingChecklist = [
  'Koleave erişimi ve kullanıcı hesabı doğrulaması',
  'Kart basımı, yemekhane tanımları ve acil durum kaydı',
  'Departman oryantasyon planı ve ilk hafta toplantıları',
  'İş sağlığı, güvenliği ve şirket prosedürlerinin paylaşımı'
];
